import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingIndicator from './LoadingIndicator';

const ProtectedRoute = ({
  children,
  requireAdmin = false,
  adminRedirectTo = '/dashboard',
}) => {
  const location = useLocation();
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return <LoadingIndicator />;
  }

  if (!isAuthenticated) {
      return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && !user?.is_admin) {
    return (
      <Navigate
        to={adminRedirectTo}
        state={{
          accessDenied:
            'Admin access is required to view that page.',
        }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
